import { Slide, Heading } from 'spectacle';

export default function Page() {
  return (
    <Slide backgroundColor="#f0db4f" textColor="#1F2022">
      <Heading padding="250px"> But first...</Heading>
    </Slide>
  );
}
